import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AppThunkDispatch } from './stores';
import { loadJwt } from './stores/auth/actions';
import Router from './routes/router';
import 'typeface-roboto';
import { officialsVersion } from 'config/version';

export default function App() {
  console.log(`%cversion: ${officialsVersion()}`, 'color: lightgreen');
  window.addEventListener(
    'contextmenu',
    e => {
      e.preventDefault();
    },
    false,
  );
  const dispatch = useDispatch<AppThunkDispatch>();
  useEffect(() => dispatch(loadJwt()), [dispatch]);

  return <Router />;
}
